/***
 * 创建人：李珊
 * 时间：2020-11-27
 * 描述: 查询抓取任务列表，删除抓取任务，对某条任务进行重新抓取
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from '../../../../../librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { Router } from '@angular/router';
import { KmsService } from '../../../kms.service';
@Component({
  selector: 'app-material-capture',
  templateUrl: './material-capture.component.html',
  styleUrls: ['./material-capture.component.css']
})
export class MaterialCaptureComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;    //表格
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
  // 查询参数：词条关键字
  termName: string = '';
  // 查询参数：抓取源id
  websiteId: string = '';
  // 所有抓取源列表
  grabSourceList = [];
  // 是否显示正在加载
  isLoading = false;
  datas: any = [];
  //  表格选中行数据
  selectData: any = [];
  // 按钮数组
  toolbar = [
    { status: true, functionCode: 'add', functionName: '添加', icon: 'glyphicon glyphicon-plus', children: [] },
    { status: true, functionCode: 'delete', functionName: '删除', icon: 'glyphicon glyphicon-trash', children: [] },
    { status: true, functionCode: 'grab', functionName: '启动抓取服务', icon: 'glyphicon glyphicon-wrench', children: [] }
  ];
  // 分页参数
  pageBase: any = {
    current: 1,
    size: 8
  };

  constructor(
    private box: SwMassageBoxService,
    private router: Router,
    private kmsService: KmsService) {
  }

  ngOnInit() {
    // 查询抓取源列表
    this.querySourceList();
    // 查询抓取任务列表
    this.clickSelect();
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.clickSelect();
    }
  }

  // 查询方法
  clickSelect() {
    this.pageBase = {
      current: 1,
      size: 8
    };
    this.getData();
  }

  //获取表格数据
  getData() {
    this.isLoading = true;
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      termName: this.termName,
      websiteId: this.websiteId
    }
    this.isLoading = false;
    this.kmsService.getCrawlTask(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          this.datas = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 重置方法
  clickReload() {
    this.termName = '';
    this.websiteId = '';
    this.pageBase = {
      current: 1,
      size: 8
    };
    this.getData();
  }

  //  表格选择数据
  outSelectData(event) {
    //获取当前选中的所有数据
    this.selectData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectData.length == 0) {
      this.swtable.toolbarDisable("delete");
    };
  }

  // 按钮点击事件
  onOperation(event) {
    switch (event) {
      // 添加方法
      case 'add':
        this.clickAdd();
        break;
      // 删除方法
      case 'delete':
        this.clickDelete();
        break;
      // 抓取方法
      case 'grab':
        this.startGrabService();
        break;
    }
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 启动当前抓取任务
    if (type == 'grab') {
      this.startGrabTask(data);
    }
    // 删除
    else if (type == 'delete') {
      this.delete([data.taskId]);
    }
  }

  // 添加方法
  clickAdd() {
    this.router.navigate(['/kms/WebPageCapture'], { queryParams: { Title: '网页抓取' } });
  }

  // 批量删除
  clickDelete() {
    if (this.selectData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    const len = this.selectData.filter(item => item.taskState == 2).length;
    if (len > 0) {
      this.box.danger('请选择待抓取或已抓取的任务进行删除！');
      return;
    }
    let ids = [];
    this.selectData.forEach(item => {
      ids.push(item.taskId);
    });
    this.delete(ids);
  }

  // 抓取方法
  startGrabService() {
    this.box.info('抓取服务正在启动中...');
    this.kmsService.startCrawlService({}).subscribe(
      data => {
        setTimeout(()=>{
          if (data.code == '200') {
            this.box.success('抓取服务启动成功！');
          } else {
            this.box.waring('抓取服务启动失败！');
          }
        },1000);
      }
    );
  }

  // 启动当前抓取任务
  startGrabTask(data) {
    this.kmsService.startTask('taskId='+data.taskId).subscribe(
      data => {
        if (data.code == '200') {
          this.box.success('正在执行当前抓取任务！');
          this.getData();
        } else {
          this.box.waring('当前抓取任务启动失败！');
        }
      }
    );
  }

  // 删除方法
  delete(ids){
    this.trim.openCLick('确认删除吗？', (data) => {
      if (data) {
        this.kmsService.deleteCrawlTaskById(ids).subscribe(
          data => {
            if (data.code == '200') {
              this.box.success('删除成功！');
              this.clickSelect();
              this.selectData = [];
            } else {
              this.box.waring(data.msg);
            }
          }
        );
      }
    });
  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase = { current: event.current, size: event.size };
    this.getData();
  }

  // 查询抓取源列表
  querySourceList() {
    this.kmsService.getCrawlWebsite({current:1,size:50}).subscribe(
      data => {
        if (data.code == '200') {
          this.grabSourceList = data.data.records;
          for (let i = 0; i < this.grabSourceList.length; i++) {
            this.grabSourceList[i].id = this.grabSourceList[i].websiteId;
            this.grabSourceList[i].text = this.grabSourceList[i].websiteName;
          }
        } else {
          this.box.waring('服务器异常，请稍候再试！');
        }
      }
    );
  }
}



